import { isEqual } from 'lodash/fp';

import { ApplicationState } from '../../../../../store/types';
import { MLData } from '../../../../datasets/store/mlTypes';
import { AnalysisView } from '../../../../documents/store/types';
import { ColumnSort, TableFilters } from '../../../../shared/table/types';
import { getFewShotDocumentsRoot } from '../../store/selectors';
import { DocumentNameFewShotPriorityOrder, FewShotDocumentQuery, FewShotDocumentTable, FewShotDocumentUploadInfo, MLFewShotDocument } from './types';

export const getSelectedAgreementTypeId = (state: ApplicationState): number | null => getFewShotDocumentsRoot(state).selectedAgreementTypeId;

export const getIsFetchingDocuments = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).isFetchingDocuments;

export const getFewShotDocuments = (state: ApplicationState): FewShotDocumentTable[] => getFewShotDocumentsRoot(state).documents;

export const getFewShotDocumentsTotal = (state: ApplicationState): number => getFewShotDocumentsRoot(state).documentsTotal;

export const getUploadModalOpen = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).uploadModalOpen;

export const getIsUploading = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).isUploading;

export const getTableFilters = (state: ApplicationState): TableFilters => getFewShotDocumentsRoot(state).tableFilters;
export const getTablePageNumber = (state: ApplicationState): number => getFewShotDocumentsRoot(state).tablePageNumber;
export const getTableColumnSort = (state: ApplicationState): ColumnSort | undefined => getFewShotDocumentsRoot(state).tableColumnSort;
export const getTablePageSize = (state: ApplicationState): number => getFewShotDocumentsRoot(state).tablePageSize;

export const getFewShotDocument = (state: ApplicationState): MLFewShotDocument | null => getFewShotDocumentsRoot(state).document;

export const getSavedFewShotDocument = (state: ApplicationState): MLFewShotDocument | null => getFewShotDocumentsRoot(state).savedDocument;

export const getFewShotDocumentUrl = (state: ApplicationState): string | null => getFewShotDocumentsRoot(state).documentUrl;

export const getFewShotAnswers = (state: ApplicationState): MLData | null => getFewShotDocument(state)?.fewShotAnswers || null;

export const getIsOpening = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).isOpening;

export const getFewShotDocumentAnalysisView = (state: ApplicationState): AnalysisView => getFewShotDocumentsRoot(state).analysisView;

export const getFewShotQueries = (state: ApplicationState): FewShotDocumentQuery[] => getFewShotDocumentsRoot(state).queries;

export const getFilesToUpload = (state: ApplicationState): File[] | null => getFewShotDocumentsRoot(state).filesToUpload;

export const getFileUploadInformation = (state: ApplicationState): FewShotDocumentUploadInfo[] => getFewShotDocumentsRoot(state).fileInformation;

export const getSelectedPage = (state: ApplicationState): number | null => getFewShotDocumentsRoot(state).selectedPage;

export const getDocumentToDelete = (state: ApplicationState): FewShotDocumentTable | null => getFewShotDocumentsRoot(state).documentToDelete;

export const getIsDeleting = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).isDeleting;

export const getSavedPriorityOrder = (state: ApplicationState): DocumentNameFewShotPriorityOrder => getFewShotDocumentsRoot(state).savedPriorityOrder;

export const getCurrentPriorityOrder = (state: ApplicationState): DocumentNameFewShotPriorityOrder => getFewShotDocumentsRoot(state).currentPriorityOrder;

export const getPriorityOrderHasUpdated = (state: ApplicationState): boolean => !isEqual(getSavedPriorityOrder(state), getCurrentPriorityOrder(state));

export const getPriorityModalOpen = (state: ApplicationState): boolean => getFewShotDocumentsRoot(state).priorityModalOpen;
